// import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import vuetify from './plugins/vuetify';
import VuetifyToast from 'vuetify-toast-snackbar'
import { DateTime,Interval } from "luxon";

//import NProgress from "nprogress"
//import "nprogress/nprogress.css"

Vue.config.productionTip = false;

// --------------------------------------------
// Amplifyの設定
// --------------------------------------------

// フルインストール
////import Amplify, * as AmplifyModules  from 'aws-amplify'
//import Amplify  from 'aws-amplify'

// 個別インストール
// Amplify/Cognitoの設定は廃止（Noritama認証へ移行）

// --------------------------------------------
// 共通ユーティリティの読み込み
// --------------------------------------------
import Util from './Util';
import { appEnv } from './tenant';

if (!window.app){
  window.app = {};
}
window.app.util = Util;

// --------------------------------------------
// 設定ファイルの読み込み(env)
// --------------------------------------------
// ビルド時の環境変数を、アクセスしたホスト名の会社の設定で上書きしたもの（SPEC-039）
window.app.env = appEnv;

// --------------------------------------------
// GoogleAnalyticsの設定
// --------------------------------------------
//console.log("VUE_APP_TRACKING_ID=" + process.env.VUE_APP_TRACKING_ID);
//gtag('config', process.env.VUE_APP_TRACKING_ID);

// --------------------------------------------
// EventHubの設定
// --------------------------------------------
import eventHub from './plugins/EventHub';
Vue.use(eventHub);

// --------------------------------------------
// axios
// --------------------------------------------
Vue.prototype.$http = axios;
// IE11のキャッシュ対応
axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {};
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams)
      config.params.append('_', Date.now());
    else
      config.params._ = Date.now();
  }

  return config;
});

// --------------------------------------------
// Vuetify Toast Snackbar
// https://github.com/eolant/vuetify-toast-snackbar
// --------------------------------------------
Vue.use(VuetifyToast, {
  x: 'center',
  y: 'bottom',
  color: 'info', // default
  icon: 'info',
  iconColor: '', // default
  classes: [
    'body-2'
  ],
  timeout: 3000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: false, // default
  showClose: false, // default
  closeText: '', // default
  closeColor: '', // default
  shorts: {
    custom: {
      color: 'purple'
    }
  },
  property: '$toast' // default
});



// --------------------------------------------
// 画面遷移のガード処理
// --------------------------------------------
router.beforeEach((to, from, next) => {
  //NProgress.start();

  // ログインしなくても確認できる画面であるか判定
  let isPublic = to.matched.some(record => record.meta.isPublic);

  let loggedIn = store.getters.isAuthenticated;

  let path = to.path;

  // ログインされているのにlogin画面を表示したら(ブックマークされてたり)
  // home画面へ遷移させる
  if (path === "/login" && loggedIn){
    next({ path: '/'});
  }
  else if (!isPublic && !loggedIn){


    let redirectPath = "";
    if (!!path && (path !== "/") && (path !== "/login")){
      redirectPath = window.app.util.combineUrl(window.app.location.baseurl,to.fullPath);
    }

    console.log("redirectPath to.path = " + path);

    next({ path: '/login', query: { backuri: redirectPath }});
  }
  else {
    next();
  }

});

let appTitle = appEnv.VUE_APP_TITLE;
if (appTitle) {
  document.title = appTitle;
}

// --------------------------------------------
// 画面遷移後の処理
// --------------------------------------------
router.afterEach((to, from) => {

  //NProgress.done();

  // metaでタイトルを更新
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + " - " + appTitle
  }

});


// --------------------------------------------
// Scrollディレクティブの定義
// --------------------------------------------
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    };
    window.addEventListener('scroll', f)
  }
});


// --------------------------------------------
// 共通コンポーネントの読み込み
// --------------------------------------------

// DatePicker(IE11対応)
//import Datepicker from 'vuejs-datepicker';
//Vue.component("vuejs-datepicker",Datepicker);
//import Datepicker from 'vue-bulma-datepicker'

import IconBase from "./components/controls/IconBase";
Vue.component("icon-base",IconBase);
import EmoteIconBase from "./components/controls/EmoteIconBase";
Vue.component("emote-icon-base",EmoteIconBase);

import LoadingView from "./components/controls/LoadingView";
Vue.component("loading-view",LoadingView);

// 共通CSSの読み込み
import "./dazaifu.scss"
import "./dazaifu_print.scss"


let appStarted = false;

let startApp = function () {

  appStarted = true;

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
};



// --------------------------------------------
// クライアントリビジョン管理
// --------------------------------------------
// 同じリビジョンへのリロードの記録（リロードの繰り返し防止）
const REVISION_RELOAD_KEY = 'REVISION_RELOAD';
const REVISION_RELOAD_INTERVAL_MS = 5 * 60 * 1000;

// 以前のクライアントは localStorage の 'REVISION' と比べてリロード要否を判断している。
// ブラウザのキャッシュに残った以前のクライアントが動いたときに必ずリロードされるよう、
// 新しいクライアントの起動時に 'REVISION' を消しておく（以前のクライアントは未設定ならリロードする）。
localStorage.removeItem('REVISION');

let checkRevision = function () {

  let dt = DateTime.now();
  let needCheck = false;
  if (!window.app.lastRevisionCheckTime) {
    needCheck = true;
  }
  else {    
    let interval = Interval.fromDateTimes(window.app.lastRevisionCheckTime,dt);
    let pastmin = interval.length("minutes");
    //console.log("前回のチェックから" + pastmin + "分経過しています。");
    if (pastmin > 60) needCheck = true;
  }
  if (!needCheck) return Promise.resolve();


  // 動いているクライアント自身のリビジョン（ビルド時に public/revision.json から埋め込んだ値）
  let curRev = Number(process.env.VUE_APP_REVISION);
  console.log("現在のクライアントバージョン:", curRev);

  // 最終のチェック時間を保持しておく
  window.app.lastRevisionCheckTime = dt;


  return new Promise((resolve, reject) => {

    let hash = new Date().getTime();

    axios.get('/revision.json?' + hash).then(response => {
      console.log("client revision", response)
      let nextRev = Number(response.data.revision);
      if (nextRev && curRev < nextRev) {

        // リロードしても新しいクライアントが届かない場合（CDN の反映待ちなど）に
        // リロードを繰り返さないよう、同じリビジョンへのリロードは一定時間に1回までとする。
        let last = null;
        try {
          last = JSON.parse(localStorage.getItem(REVISION_RELOAD_KEY));
        } catch (e) {
          last = null;
        }
        let now = Date.now();
        if (!last || last.revision !== nextRev || now - last.at > REVISION_RELOAD_INTERVAL_MS) {
          console.log("新バージョンが確認されたため念の為リロードします。",nextRev);
          localStorage.setItem(REVISION_RELOAD_KEY, JSON.stringify({ revision: nextRev, at: now }));

          // リロード処理
          location.reload();
        }
        else {
          console.log("新バージョンへのリロード直後のため、リロードを見送ります。",nextRev);
        }
      }
      resolve("ok");
    })
      .catch(error => {
        console.log(error)
        reject(error)
      });
  });
    
};
window.app.checkRevision = checkRevision;
window.app.lastRevisionCheckTime = 0;



// --------------------------------------------
// アプリ起動フロー
// --------------------------------------------
import Authentication from './authentication'

Authentication.checkLogin()
    .then(data => {

        if (data && data.idToken){
          axios.defaults.headers.common["Authorization"] = data.idToken;
        }
        store.commit('setApiAuthorization', data);

        startApp();

    })
    .catch(err => {
        axios.defaults.headers.common["Authorization"] = "";
        startApp();
    });

// 設定ファイルの選択をログ
console.log("ENV_NAME=" + process.env.VUE_APP_ENV_NAME);
